export const mobileDeviceLabel = ({ type, name }: { type: 'android' | 'ios'; name: string }): string => {
    if (type === 'ios') {
        // The app registers a device under its model name, which starts with iPad on every iPad.
        return `${name} · ${name.startsWith('iPad') ? 'iPadOS' : 'iOS'}`;
    }

    return `${name} · Android`;
};
